import { render, staticRenderFns } from "./youshi.vue?vue&type=template&id=6808358c&scoped=true&"
import script from "./youshi.vue?vue&type=script&lang=js&"
export * from "./youshi.vue?vue&type=script&lang=js&"
import style0 from "./youshi.vue?vue&type=style&index=0&id=6808358c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808358c",
  null
  
)

export default component.exports